import { isEmpty } from "lodash";
import * as React from "react";
import { Keys } from "~/common/enums";
import { imageAnnotationsResx } from "~/resxDist/imageAnnotationsResx";
import { ButtonContrast, ButtonPositive, ButtonsGroup } from "~/sharedComponents/buttons";
import { DataObject } from "~/sharedComponents/imageAnnotation/components/Annotation";
import { Flex } from "~/sharedComponents/layout";
import { FocusTrap } from "~/sharedHOC/adjustContainer/FocusTrap";
import { WithKeyHandlers } from "~/sharedHOC/WithKeyHandlers/WithKeyHandlers";
import { AnnotationItemExtended } from "../types";
import { ImageAnnotationMessageContainer } from "./ImageAnnotationMessageContainer";
import { comment_editor } from "./ImageAnnotationsEditor.less";

export interface AnnotationTextAreaProps {
    onChange: F1<AnnotationItemExtended, void>;
    onCancel: F<void>; // typeof clearAnnotation;
    onSubmit: F<void>;
    annotation: AnnotationItemExtended;
    withScroll?: boolean;
}

export class AnnotationTextArea extends React.Component<AnnotationTextAreaProps> {
    constructor(props: AnnotationTextAreaProps) {
        super(props);
        this.onChangeComment = this.onChangeComment.bind(this);
    }

    onChangeComment = (value: string) => {
        this.props.onChange({
            ...this.props.annotation,
            data: {
                ...this.props.annotation.data,
                text: value,
            },
        });
        return value;
    };

    render() {
        const { annotation, onCancel, onSubmit } = this.props;
        const { data } = annotation;
        const textAreaValue = data?.text ?? "";
        const simpleEditorShown = isSimpleEditor(data);

        // fix for adding new annotation if currently user in inline edit for existing one.
        // (force reinitialize editor state)
        const editorKey = data?.id ?? 0;

        return (
            <div className={comment_editor}>
                <FocusTrap autoFocus={false} enforceFocus={true}>
                    <WithKeyHandlers
                        actionsOnKeyDown={[
                            {
                                key: Keys.Escape,
                                action: onCancel,
                                preventDefault: true,
                            },
                            {
                                key: Keys.ArrowLeft,
                                action: () => {
                                    return;
                                },
                                stopPropagation: true,
                            },
                            {
                                key: Keys.ArrowRight,
                                action: () => {
                                    return;
                                },
                                stopPropagation: true,
                            },
                            {
                                key: Keys.Enter,
                                withCtrlKey: true,
                                action: onSubmit,
                            },
                        ]}
                    >
                        <ImageAnnotationMessageContainer
                            key={editorKey}
                            annotation={this.props.annotation}
                            value={textAreaValue}
                            onChange={this.onChangeComment}
                            withScroll={this.props.withScroll}
                        />
                        {!simpleEditorShown && (
                            <Flex justifyContent="end" marginTop={24}>
                                <ButtonsGroup>
                                    <ButtonContrast text={imageAnnotationsResx.cancel} action={onCancel} />
                                    <ButtonPositive
                                        disabled={textAreaValue === ""}
                                        text={
                                            this.props.annotation.message
                                                ? imageAnnotationsResx.apply
                                                : imageAnnotationsResx.comment
                                        }
                                        action={onSubmit}
                                    />
                                </ButtonsGroup>
                            </Flex>
                        )}
                    </WithKeyHandlers>
                </FocusTrap>
            </div>
        );
    }
}

const isSimpleEditor = (data: DataObject) => {
    if (isEmpty(data)) {
        return true;
    } else if (data.id || data.text) {
        return false;
    }
    return true;
};
